
// //const { BASE_URL } = process.env;
// //rest api routes constants
// console.log(BASE_URL);

export const BASE_API_URI = process.env.REACT_APP_API_BASE_URL;
// export const BASE_API_URI = 'http://localhost:8001/services';
//export const BASE_API_URI = 'http://a84dd1e8fdf5e4007803d7a33da800a4-572208768.us-east-2.elb.amazonaws.com/login';
//export const BASE_API_URI = 'https://transportation.caretap.net:8002';
export const GET_STATE_URI = BASE_API_URI+'/getAllState';
export const ADD_PASSENGER_URI = BASE_API_URI+'/add-passenger';       
export const GET_PASSENGER_URI = BASE_API_URI+'/getPassengerList';
export const GET_PASSENGERV1_URI = BASE_API_URI+'/passengers/v1';
export const GET_PASSENGER_LIST = BASE_API_URI+'/passengerList';
export const GET_SCHEPASSENGER_LIST = BASE_API_URI+'/scheduledPassengerList';
export const ADD_DRIVER_URI = BASE_API_URI+'/add-driver';
export const GET_DRIVER_URI = BASE_API_URI+'/getDriverList';
export const GET_DRIVER_LIST = BASE_API_URI+'/driverList';
export const GET_DRIVER_LIST_V1 = BASE_API_URI+'/driverList/v1';
/** PATCH `{UPDATE_DRIVER_STATUS}/{driverId}` — body `{ isActive: 0|1 }` */
export const UPDATE_DRIVER_STATUS = `${BASE_API_URI}/driver`;
export const ADD_VEHICLE_URI = BASE_API_URI+'/add-vehicle';
export const ADD_VEHICLE_List = BASE_API_URI+'/getVehicleList';
export const ADD_LOCATION_URL = BASE_API_URI+'/add-location';
//export const UPDATE_LOCATION_URL = BASE_API_URI+'/updateLocation';
export const GET_LOCATION_URL = BASE_API_URI+'/getLocation';
export const GET_DRIVER_URL = BASE_API_URI+'/getDriverList';
export const GET_DRIVER_URL_V1 = BASE_API_URI+'/getDriverList/v1';


export const GET_ALL_DRIVER_URL = BASE_API_URI+'/getAllDriverList';
export const ADD_SCHEDULE_URL = BASE_API_URI+'/add-schedule';
// v1 add schedule endpoint (keep old ADD_SCHEDULE_URL for backward compatibility)
export const ADD_SCHEDULE_V1_URL = `${BASE_API_URI}/schedules/v1`;
export const GET_SCHEDULE_LIST = BASE_API_URI+'/getScheduleList';
/** GET paginated schedule list (query: page, limit, from_date, to_date, passenger_id, driver_id, pmi_no, payer_id, optional assigned_or_not, schedule_id) */
export const GET_SCHEDULE_LIST_V1 = `${BASE_API_URI}/schedules/v1`;
/** PATCH assign driver to a leg: `/assigndriver/v1/:schedule_trans_id` body `{ driverId }` */
export const ASSIGN_DRIVER_V1 = `${BASE_API_URI}/assigndriver/v1`;
/** GET v1 add trip list — query: page, limit, startDate, endDate, passengerId, payerId */
export const GET_ADD_TRIP_LIST = `${BASE_API_URI}/addTripList/v1`;
export const GET_EDIT_PASSENGER = BASE_API_URI+'/getViewPassenger';
export const GET_DELETE_ASSIGNED_DRIVER = BASE_API_URI+'/deleteAssignedDriver';
export const UPDATE_PASSENGER = BASE_API_URI+'/updatePassenger';
export const TRIP_LIST = BASE_API_URI+'/tripList';
export const TRIP_LIST_V1 = `${BASE_API_URI}/trips/v1`;
export const ADD_TRIP = BASE_API_URI+'/createTrip';
export const GET_EDIT_DRIVER = BASE_API_URI+'/getEditDriver';
export const DELETE_ASSIGNED_PASSENGER = BASE_API_URI+'/deleteAssignedPassenger';
export const UPDATE_DRIVER = BASE_API_URI+'/updateDriver';
export const GET_EDIT_VEHICLE = BASE_API_URI+'/getEditVehicle';
export const UPDATE_VEHICLE = BASE_API_URI+'/updateVehicle';
export const GET_EDIT_PASSENGER_LIST = BASE_API_URI+'/scheduledEditPassenger';
export const GET_EDIT_SCHEDULE = BASE_API_URI+'/getEditSchedule';
export const UPDATE_SCHEDULE = BASE_API_URI+'/updateSchedule';
export const CREATE_AGENCY = BASE_API_URI+'/createAgency';
export const GET_AGENCY_URL = BASE_API_URI+'/agency';
export const VIEW_AGENCY_EDIT = BASE_API_URI+'/viewAgency';
export const UPDATE_AGENCY = BASE_API_URI+'/updateAgency';
export const CHECK_EXISTING_USER = BASE_API_URI+'/checkExistingUser';
export const DELETE_PASSENGER = BASE_API_URI+'/deletePassenger';
export const DELETE_TRIP = BASE_API_URI+'/deleteTrip';
export const DELETE_TRIP_V1 = `${BASE_API_URI}/trips/v1`;
export const DELETE_VEHICLE_ASSIGNED_DRIVER = BASE_API_URI+'/deleteVehicleDriver';
export const ADD_CHECK_LIST = BASE_API_URI+'/add-checkList';
export const GET_CHECK_LIST = BASE_API_URI+'/getCheckList';
export const UPDATE_CHECK_LIST = BASE_API_URI+'/updateCheckList';
export const EDIT_CHECKLIST_VALUE = BASE_API_URI+'/editCheckList';
export const ADD_SCHEDULE_DRIVER = BASE_API_URI+'/scheduledDriver';
/** DELETE `{DELETE_SCHEDULE}/{schedule_id}` — v1 schedule delete */
export const DELETE_SCHEDULE = `${BASE_API_URI}/schedules/v1`;
/** DELETE body `{ ids: schedule_id[] }` — bulk schedule delete */
export const DELETE_MULTIPLE_SCHEDULES = `${BASE_API_URI}/deleteMultipleSchedules`;
export const UPLOAD_SCHEDULE = BASE_API_URI+'/uploadSchedule';
export const GET_ALL_PAYER = BASE_API_URI+'/getAllPayer';
export const CREATE_PAYER = BASE_API_URI+'/addPayer';
export const PAYER_EDIT = BASE_API_URI+'/editPayer';
export const UPDATE_PAYER = BASE_API_URI+'/updatePayer';
export const BILLING_LIST = BASE_API_URI+'/billingList';
/** GET v1 billing list — query: page, limit, startDate, endDate, passengerId, payerId, driverId, billingStatus, tripStatus */
export const BILLING_LIST_V1 = `${BASE_API_URI}/billing/v1`;
export const BILLING_SUMMARY = `${BASE_API_URI}/billingSummary/v1`;
export const GET_BILLING_INFO = BASE_API_URI+'/billingInfo';
export const GET_BILLING_CONFIGURATION = BASE_API_URI+'/billingConfiguration';
export const CREATE_BILLING_CONFIGURATION = BASE_API_URI+'/createBillingConfiguration';
export const BILLING_PROCESS = BASE_API_URI+'/billingProcess';
export const GET_CHECKLIST_REPORT = BASE_API_URI+'/getChecklistReport';
export const CHECK_DRIVER_AVAILABILITY = BASE_API_URI+'/checkDriverAvailability';
export const GET_DRIVERS_COUNT = BASE_API_URI+'/getDriversCount';
export const GET_SCHEDULE_COUNT = BASE_API_URI+'/getScheduleCount';
export const GET_VEHICLE_COUNT = BASE_API_URI+'/getVehicleCount';
export const GET_MAINTENANCE_VEHICLE_COUNT = BASE_API_URI+'/getMaintenanceVehicleCount';
export const MAINTENANCE_VEHICLE_REPORT = BASE_API_URI+'/vehicleMaintenanceReport';
export const GET_UPCOMING_SCHEDULE = BASE_API_URI+'/getUpcomingSchedule';
export const GET_TRIP_DETAILS = BASE_API_URI+'/getTripLocation';
export const GET_DRIVER_PROFILE_DETAILS = BASE_API_URI+'/getDriverProfile';
export const GET_PASSENGER_PROFILE_DETAILS = BASE_API_URI+'/getPassengerProfile';
export const GET_SERVICE_AUTHORIZATION_LIST = BASE_API_URI+'/serviceAuthorizationList';
export const GET_TODAYS_TRIP_DETAILS = BASE_API_URI+'/getTodaysTripDetails';
export const SEND_FTP = BASE_API_URI+'/ftp';
export const GET_TOMARROW_SCHEDULE = BASE_API_URI+'/getYesterdaySchedule';
export const BILL_DETAILS = BASE_API_URI+'/getBillDetails';
// export const UPDATE_BILLING_STATUS = BASE_API_URI+'/updateBillingStatus';
export const GET_UNASSIGNED_SCHEDULE_LIST = BASE_API_URI+'/unAssignedScheduleList';
export const DELETE_VEHICLE = BASE_API_URI+'/deleteVehicle';
export const GET_VEHICLE_DETAILS = BASE_API_URI+'/getVehicleProfileDetails';
export const UPDATE_TRIP_STATUS = BASE_API_URI+'/updateTripStatus';
export const CANCEL_SCHEDULE = BASE_API_URI+'/cancelSchedule';
export const GET_LOCATION_BY_IDS = BASE_API_URI+'/getLocationByIds';
export const UPDATE_LEG_DISTANCE = BASE_API_URI+'/updateLegDistance';
export const EDIT_TRIP_MILES = BASE_API_URI+'/editTripMiles';
export const GET_SERVICE_AUTH_DETAIL = BASE_API_URI+'/passengerServiceAuth';
export const GET_OFFICE_ADMIN_URL = BASE_API_URI+'/getOfficeAdminList';
export const VEHICLE_ASSIGN_TO_DRIVER = BASE_API_URI+'/vehicleAssignToDriver';
export const GET_CHAT_USERS = BASE_API_URI+'/getChatUsers';
export const GET_CHAT_MESSAGES = BASE_API_URI+'/getChatMessages';
export const SEND_MESSAGE = BASE_API_URI+'/sendMessage';
export const MARK_MESSAGES_READ = BASE_API_URI+'/markMessagesRead';
export const GET_LOCATION_TYPE = BASE_API_URI+'/getAllLocationType';
export const CREATE_BILL_RATE_CONFIGURATION = BASE_API_URI+'/createBillRateConfiguration';
/** POST v1 bill rate configuration — dates as start_date/end_date in MM/DD/YYYY */
export const CREATE_BILL_RATE_CONFIGURATIONV1 = `${BASE_API_URI}/billRateConfiguration/v1`;
export const GET_BILL_RATE_CONFIGURATION = BASE_API_URI+'/getBillRateConfiguration';
/** GET v1 bill rate list — query: payer (use `null` when no filter) */
export const GET_BILL_RATE_CONFIGURATIONV1 = `${BASE_API_URI}/billRateConfiguration/v1`;
export const GET_BILL_RATE_BY_ID = BASE_API_URI+'/getBillRateById';
export const UPDATE_BILL_RATE_CONFIGURATION = BASE_API_URI+'/updateBillRateConfiguration';
/** PUT `{UPDATE_BILL_RATE_CONFIGURATIONV1}/{id}` — dates as start_date/end_date in MM/DD/YYYY */
export const UPDATE_BILL_RATE_CONFIGURATIONV1 = `${BASE_API_URI}/billRateConfiguration/v1`;
export const GET_SERVICE_NAMES = BASE_API_URI+'/getServiceNames';
export const GET_MA_SERVICE = BASE_API_URI+'/maservice';
/** GET v1 NEMT services list for service authorization */
export const GET_NEMT_SERVICES_V1 = `${BASE_API_URI}/nemtServices/v1`;
export const POST_SERVICE_AUTH = BASE_API_URI+'/serviceAuth';
export const GET_SERVICE_AUTH_BY_PASSENGER = BASE_API_URI+'/serviceAuth';
export const GET_SERVICE_AUTH_ACTIVE = BASE_API_URI+'/serviceAuth/active';
export const SUBMITTED_BATCH_LIST = BASE_API_URI+'/getSubmittedBatchList';
/** GET batch claim details for PDF export: `/billing/submission/:id` */
export const BILLING_SUBMISSION_DETAILS = `${BASE_API_URI}/billing/submission`;
//export const GET_PAYER_LIST = BASE_API_URI+'/addPayer';
export const DELETE_TRIP_COMPLETELY_BY_SCHEDULE_ID = BASE_API_URI+'/deleteTripCompletelyByScheduleId';
export const GET_PASSENGER = `${BASE_API_URI}/getPassengerProfileDetails`;
export const UPDATE_PASSENGER_DATA = `${BASE_API_URI}/updatePassengerProfileDetails`;
export const BILLING_INVOICE_DETAILS = `${BASE_API_URI}/billingInvoiceDetails`;
export const GET_UPLOAD_SCHEDULE_HISTORY = `${BASE_API_URI}/getUploadScheduleHistory`;
export const DOWNLOAD_SCHEDULE_FILE = `${BASE_API_URI}/downloadScheduleFile`;
export const c = `${BASE_API_URI}/schedules/bulk-update`;
export const BULK_UPDATE_BILLING_STATUS = `${BASE_API_URI}/schedules/bulk-update`;
export const UPDATE_SCHEDULE_V1 = `${BASE_API_URI}/schedules/v1/`;
/** GET/POST FTP credentials — admin only */
export const FTP_AUTH_URL = `${BASE_API_URI}/ftp/auth`;